export default __webpack_public_path__ + "static/media/deviantart.f9fea619.svg";